import { toast } from "react-toastify";

// MUTATION FEEDBACK =================================================================
export const apiErrorMessage = (
  error: unknown,
  fallback = "Action impossible",
) =>
  (error as { response?: { data?: { error?: string } } })?.response?.data
    ?.error ?? fallback;

/** Toast handlers shared by every admin mutation. */
export const notify = (success: string, then?: () => void) => ({
  onSuccess: () => {
    toast.success(success);
    then?.();
  },
  onError: (error: unknown) => {
    toast.error(apiErrorMessage(error));
  },
});
